import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminMagazines = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Magazines</h2>
        <small className="text-muted">
          Gérer les magazines
        </small>
      </div>
      
      <SchemaManager
        schemaKey="magazines"
        endpoint="/api/magazines"
      />
    </div>
  );
};

export default AdminMagazines;